import { TypeInputFreeformDate } from '@/core/generated-types';
import { ChildBirthDateInput } from '@/utils/dates/constants';
import { childBirthDateToDateString } from '@/utils/dates/dateFormatters';
import dayjs from 'dayjs';

export function validateChildBirthDate(
  event: any,
  date: Date,
  childBirthDate: ChildBirthDateInput,
  childBirthDateInput?: TypeInputFreeformDate,
) {
  const { target: form } = event;
  const formFields = form.elements;

  // No freeform date field.
  if (!childBirthDateInput) return '';

  // No data was entered.
  if (!childBirthDate.year && !childBirthDate.month && !childBirthDate.day) {
    return childBirthDateInput.fields.required
      ? childBirthDateInput.fields.requiredError || ''
      : '';
  }

  // At least one date fragment is empty.
  if (!childBirthDate.year || !childBirthDate.month || !childBirthDate.day) {
    return childBirthDateInput.fields.incompleteDateError;
  }

  const yearId = `${childBirthDateInput.fields.id}-year`;
  const monthId = `${childBirthDateInput.fields.id}-month`;
  const dayId = `${childBirthDateInput.fields.id}-day`;

  const yearIsValid = formFields[yearId]?.checkValidity();
  const monthIsValid = formFields[monthId]?.checkValidity();
  const dayIsValid = formFields[dayId]?.checkValidity();

  // Input is not a plausible date based on provided patterns (e.g., February 29 on a non-leap year, April 31, month=13, or day=90, or year=870).
  if (!yearIsValid || !monthIsValid || !dayIsValid || isNaN(date.getTime())) {
    return childBirthDateInput.fields.invalidDateError;
  }

  const dateString = childBirthDateToDateString(childBirthDate);
  const birthDate = dayjs(dateString);
  const isDateTooFarInFuture = birthDate.isAfter(dayjs().add(9, 'month'));
  const isDateTooFarInPast = birthDate.isBefore(dayjs().subtract(18, 'year'));

  if (isDateTooFarInFuture) {
    return childBirthDateInput.fields.futureDateError || '';
  }

  if (isDateTooFarInPast) {
    return childBirthDateInput.fields.tooOldError || '';
  }

  return '';
}
